<template>
  <button
    class="transition-ease-in-out mb-px block w-full bg-white py-5 px-4 text-left text-sm font-medium leading-snug text-[#4E389D] hover:text-primary-light"
    @click="openModal('roles')"
  >
    <span>
      {{ $t("homepage.switch_roles") }}
    </span>
  </button>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "CoreShowRoles.vue",
  methods: {
    ...mapMutations({
      openModal: "modals/openModal",
    }),
  },
};
</script>
